import { createFileRoute, Link } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
import { useExams } from "@/lib/query-hooks";

export const Route = createFileRoute("/admin/exams")({
  component: AdminExams,
});

function AdminExams() {
  const { data, isLoading } = useExams({ includeUnpublished: true });

  return (
    <div>
      <div className="flex items-end justify-between">
        <div>
          <div className="label-card">Exams</div>
          <h1 className="mt-1 font-display text-3xl font-semibold">All exams</h1>
        </div>
        <button className="inline-flex items-center gap-2 rounded-md bg-paprika px-3 py-2 text-xs font-semibold uppercase tracking-widest text-white">
          <PlusIcon className="h-3.5 w-3.5" /> New exam
        </button>
      </div>

      <ul className="mt-8 card-ledger divide-y divide-hairline overflow-hidden">
        {isLoading ? (
          <li className="p-6 text-ink-muted text-sm">Loading…</li>
        ) : !data?.length ? (
          <li className="p-10 text-center text-ink-soft">
            No exams yet. Add your first one.
          </li>
        ) : (
          data.map((e) => (
            <li
              key={e.id}
              className="flex items-center gap-4 px-5 py-3 hover:bg-surface-alt/40"
            >
              <div className="h-8 w-8 rounded-full border-2 border-paprika text-paprika text-[10px] font-bold grid place-items-center">
                {e.shortCode}
              </div>
              <div className="flex-1">
                <div className="font-semibold">{e.name}</div>
                <div className="text-xs text-ink-muted">
                  {e.subjectCount ?? 0} subjects · slug: {e.slug}
                </div>
              </div>
              <span
                className={`text-[10px] uppercase tracking-widest font-semibold ${
                  e.isPublished ? "text-success" : "text-warning"
                }`}
              >
                {e.isPublished ? "Published" : "Draft"}
              </span>
              <Link
                to="/admin/exams/$examId/subjects"
                params={{ examId: e.id }}
                className="text-xs text-paprika font-semibold uppercase tracking-widest"
              >
                Subjects →
              </Link>
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
